module.exports = __webpack_public_path__ + "media/phone@2x-d35ccf2f.webp";